import styled from 'styled-components'
import { ZingTheme } from '../../../assets/theme/types'

export const PopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const PopUpHeader = styled.div`
  background-color: ${({ theme }) => (theme as ZingTheme).colors.primary};
  height: 69px;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
`
export const PopUpTitle = styled.h4`
  color: ${({ theme }) => (theme as ZingTheme).colors.white};
  font-size: 20px;

  @media (max-width: 425px) {
    font-size: 18px;
  }
`
export const PopUpContent = styled.div`
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const PopUpParagraph = styled.span`
  font-size: 16px;
  line-height: 18.75px;
  color: ${({ theme }) => (theme as ZingTheme).colors.grey600};
`
